// VEPC Gestao - Central Administrativa: Financeiro Inteligente & Conferência
import { api } from '../api.js';

export async function renderMensalidades() {
  const container = document.createElement('div');
  container.className = 'view-content';

  container.innerHTML = `
    <div class="view-header">
      <div class="view-title-group">
        <div style="display: flex; align-items: center; gap: 10px;">
          <h2>Financeiro Inteligente & Mensalidades</h2>
          <span class="badge badge-beta">CONFERÊNCIA ADM</span>
        </div>
        <p>Acompanhamento de vencimentos, calendário por dia, tolerância de 5 dias, custos operacionais e conferência de pagamentos.</p>
      </div>
      <div class="view-actions">
        <button class="btn btn-secondary btn-sm" id="btn-novo-custo">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg>
          Registrar Custo Operacional
        </button>
        <button class="btn btn-primary btn-sm" id="btn-lancar-mensalidade">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          Lançar Mensalidade
        </button>
      </div>
    </div>

    <!-- Navegação por Abas do Financeiro Inteligente -->
    <div style="display: flex; gap: 10px; margin-bottom: 20px; border-bottom: 1px solid var(--vepc-border); padding-bottom: 12px;">
      <button class="btn btn-primary btn-sm aba-fin active" data-aba="faturas">
        Todas as Mensalidades & Conferência
      </button>
      <button class="btn btn-secondary btn-sm aba-fin" data-aba="calendario">
        Calendário de Vencimentos & Acompanhamento
      </button>
      <button class="btn btn-secondary btn-sm aba-fin" data-aba="custos">
        Custos Operacionais & Projeções
      </button>
    </div>

    <!-- ABA 1: TODAS AS MENSALIDADES & CONFERÊNCIA -->
    <div id="aba-conteudo-faturas">
      <div class="card-panel" style="padding: 16px 20px; margin-bottom: 20px;">
        <div style="display: flex; gap: 14px; flex-wrap: wrap; align-items: center;">
          <div>
            <select id="filtro-status-men" class="form-control" style="width: 210px;">
              <option value="">Todos os Status</option>
              <option value="aguardando_conferencia">Aguardando Conferência (Já Paguei)</option>
              <option value="em_aberto">Em Aberto / Vencidas</option>
              <option value="paga">Pagas / Conferidas</option>
              <option value="isenta">Isentas</option>
            </select>
          </div>
          <button class="btn btn-secondary btn-sm" id="btn-filtrar-men">Filtrar</button>
        </div>
      </div>

      <div class="card-panel">
        <div class="table-responsive">
          <table class="data-table">
            <thead>
              <tr>
                <th>Empresa</th>
                <th>Competência</th>
                <th>Valor</th>
                <th>Vencimento</th>
                <th>Carência (5 dias)</th>
                <th>Status</th>
                <th>Situação Prazo</th>
                <th style="text-align: right;">Ações de Conferência</th>
              </tr>
            </thead>
            <tbody id="corpo-tabela-mensalidades">
              <tr><td colspan="8" style="text-align: center; padding: 30px;">Carregando faturas...</td></tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- ABA 2: CALENDÁRIO DE VENCIMENTOS & CLIENTES EM ACOMPANHAMENTO -->
    <div id="aba-conteudo-calendario" style="display: none;">
      <!-- Grid de Dias de Vencimento -->
      <div class="card-panel" style="margin-bottom: 22px;">
        <div class="panel-header">
          <span class="panel-title">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            Calendário de Cortes & Vencimentos (Competência Atual)
          </span>
        </div>
        <div class="panel-body">
          <div id="calendario-cards-grid" style="display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px;">
            <div style="text-align: center; color: var(--vepc-text-muted); grid-column: span 5; padding: 20px;">Carregando calendário...</div>
          </div>
        </div>
      </div>

      <!-- Tabela de Clientes em Acompanhamento (Atrasados ou Tolerância de 5 dias) -->
      <div class="card-panel">
        <div class="panel-header">
          <span class="panel-title" style="color: #FBBF24;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
            Clientes que Precisam de Acompanhamento (Atraso / Carência de 5 dias)
          </span>
          <span style="font-size: 11.5px; color: var(--vepc-text-muted);">Controle preventivo antes de qualquer limitação</span>
        </div>
        <div class="panel-body" style="padding: 0;">
          <div class="table-responsive">
            <table class="data-table" id="tabela-acompanhamento">
              <thead>
                <tr>
                  <th>Empresa</th>
                  <th>Contato do Gestor</th>
                  <th>Plano</th>
                  <th>Valor</th>
                  <th>Vencimento</th>
                  <th>Limite Carência</th>
                  <th>Situação</th>
                </tr>
              </thead>
              <tbody id="corpo-tabela-acompanhamento">
                <tr><td colspan="7" style="text-align: center; padding: 30px;">Carregando lista de acompanhamento...</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- ABA 3: CUSTOS OPERACIONAIS & PROJEÇÕES -->
    <div id="aba-conteudo-custos" style="display: none;">
      <div style="display: grid; grid-template-columns: 2fr 1fr; gap: 20px;">
        <!-- Tabela de Custos Operacionais Registrados -->
        <div class="card-panel">
          <div class="panel-header">
            <span class="panel-title">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>
              Custos Operacionais Reais Registrados
            </span>
            <button class="btn btn-secondary btn-sm" id="btn-novo-custo-aba">+ Novo Custo</button>
          </div>
          <div class="panel-body" style="padding: 0;">
            <div class="table-responsive">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>Competência</th>
                    <th>Categoria</th>
                    <th>Descrição</th>
                    <th>Valor</th>
                    <th>Comprovante / Premissa</th>
                  </tr>
                </thead>
                <tbody id="corpo-tabela-custos">
                  <tr><td colspan="5" style="text-align: center; padding: 30px;">Carregando custos...</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Projeções de Faturamento Futuro -->
        <div class="card-panel">
          <div class="panel-header">
            <span class="panel-title">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
              Projeções de Receita Futura
            </span>
          </div>
          <div class="panel-body" id="container-projecoes">
            <div style="text-align: center; color: var(--vepc-text-muted); padding: 20px;">Carregando projeções...</div>
          </div>
        </div>
      </div>
    </div>

    <div id="modal-container-mensalidades"></div>
  `;

  const tbody = container.querySelector('#corpo-tabela-mensalidades');
  const modalContainer = container.querySelector('#modal-container-mensalidades');

  // Gerenciamento de Troca de Abas
  const abas = container.querySelectorAll('.aba-fin');
  const conteudoFaturas = container.querySelector('#aba-conteudo-faturas');
  const conteudoCalendario = container.querySelector('#aba-conteudo-calendario');
  const conteudoCustos = container.querySelector('#aba-conteudo-custos');

  abas.forEach(btn => {
    btn.addEventListener('click', () => {
      abas.forEach(b => { b.classList.remove('active', 'btn-primary'); b.classList.add('btn-secondary'); });
      btn.classList.add('active', 'btn-primary');
      btn.classList.remove('btn-secondary');

      const aba = btn.dataset.aba;
      conteudoFaturas.style.display = aba === 'faturas' ? 'block' : 'none';
      conteudoCalendario.style.display = aba === 'calendario' ? 'block' : 'none';
      conteudoCustos.style.display = aba === 'custos' ? 'block' : 'none';

      if (aba === 'calendario' || aba === 'custos') {
        carregarAnaliseFinanceira();
      }
    });
  });

  // CARREGAR FATURAS (ABA 1)
  async function carregarMensalidades() {
    const status = container.querySelector('#filtro-status-men').value;
    let qs = status ? `?status=${encodeURIComponent(status)}` : '';

    try {
      const data = await api.getMensalidades(qs);
      const mensalidades = data.mensalidades || [];

      if (mensalidades.length === 0) {
        tbody.innerHTML = `<tr><td colspan="8" style="text-align: center; padding: 40px; color: var(--vepc-text-muted);">Nenhuma mensalidade encontrada.</td></tr>`;
        return;
      }

      tbody.innerHTML = mensalidades.map(m => {
        let badgePrazo = '<span class="badge badge-sucesso">EM DIA</span>';
        if (m.situacao_prazo === 'em_carencia') {
          badgePrazo = '<span class="badge badge-aguardando" title="Dentro da tolerância de 5 dias">EM CARÊNCIA</span>';
        } else if (m.situacao_prazo === 'em_atraso') {
          badgePrazo = '<span class="badge badge-vencida">EM ATRASO</span>';
        } else if (m.situacao_prazo === 'no_prazo') {
          badgePrazo = '<span class="badge badge-aberto">A VENCER</span>';
        }

        return `
          <tr>
            <td>
              <div style="font-weight: 800; color: #FFFFFF;">${m.empresa_nome}</div>
              <div style="font-size: 11px; color: var(--vepc-text-muted);">${m.empresa_responsavel || ''}</div>
            </td>
            <td><code style="font-family: var(--font-mono); color: #CBD5E1;">${m.competencia}</code></td>
            <td>
              <span class="price-pill" style="color: var(--vepc-dourado-claro);">
                R$ ${(m.valor_centavos / 100).toFixed(2).replace('.', ',')}
              </span>
            </td>
            <td style="font-family: var(--font-mono); color: #E2E8F0;">
              ${new Date(m.vencimento + 'T12:00:00').toLocaleDateString('pt-BR')}
            </td>
            <td style="font-size: 11.5px; color: var(--vepc-text-subtle);">
              ${m.data_limite_carencia ? new Date(m.data_limite_carencia + 'T12:00:00').toLocaleDateString('pt-BR') : '—'}
            </td>
            <td><span class="badge badge-${m.status}">${m.status.toUpperCase()}</span></td>
            <td>${badgePrazo}</td>
            <td style="text-align: right; white-space: nowrap;">
              ${m.status === 'aguardando_conferencia' ? `
                <button class="btn btn-gold btn-sm btn-conferir" data-id="${m.id}" title="Conferir comprovante administrativo">
                  Conferir Pix
                </button>
              ` : ''}
              ${m.status === 'em_aberto' ? `
                <button class="btn btn-secondary btn-sm btn-simular-jp" data-id="${m.id}" title="Simular solicitação Já Paguei pelo cliente">
                  Simular "Já Paguei"
                </button>
              ` : ''}
              ${m.status === 'paga' ? `
                <span style="font-size: 11px; color: #10B981; font-weight: 700;">✔ PAGO EM ${m.pago_em ? new Date(m.pago_em + 'T12:00:00').toLocaleDateString('pt-BR') : ''}</span>
              ` : ''}
            </td>
          </tr>
        `;
      }).join('');

      // Eventos de Simulação "Já Paguei"
      tbody.querySelectorAll('.btn-simular-jp').forEach(btn => {
        btn.addEventListener('click', async () => {
          const id = btn.dataset.id;
          const obs = prompt('Informe a observação do cliente ao acionar "Já Paguei" (opcional):', 'Comprovante Pix enviado via WhatsApp');
          if (obs !== null) {
            try {
              await api.simularJaPaguei(id, { observacao: obs });
              alert('Solicitação "Já Paguei" registrada com sucesso! Fatura agora está em aguardo de conferência.');
              carregarMensalidades();
            } catch (err) {
              alert('Erro: ' + err.message);
            }
          }
        });
      });

      // Eventos de Conferência Administrativa
      tbody.querySelectorAll('.btn-conferir').forEach(btn => {
        btn.addEventListener('click', () => abrirModalConferencia(btn.dataset.id));
      });

    } catch (err) {
      tbody.innerHTML = `<tr><td colspan="8" style="text-align: center; color: var(--vepc-danger); padding: 30px;">Falha ao carregar mensalidades: ${err.message}</td></tr>`;
    }
  }

  // CARREGAR ANÁLISE FINANCEIRA (ABAS 2 E 3)
  async function carregarAnaliseFinanceira() {
    try {
      const data = await api.getFinanceiroAnalise();

      // 1. Calendário de Cortes (Dias 5, 10, 15, 20, 25)
      const calDiv = container.querySelector('#calendario-cards-grid');
      const cal = data.calendario_vencimentos || [];

      if (cal.length === 0) {
        calDiv.innerHTML = `<div style="text-align: center; color: var(--vepc-text-muted); grid-column: span 5; padding: 20px;">Nenhum vencimento registrado nesta competência.</div>`;
      } else {
        calDiv.innerHTML = cal.map(c => `
          <div style="background: var(--vepc-surface-subtle); border: 1px solid var(--vepc-border); border-radius: var(--radius-md); padding: 14px; text-align: center;">
            <div style="font-size: 11px; font-weight: 700; color: var(--vepc-text-muted); text-transform: uppercase;">Vencimento</div>
            <div style="font-size: 22px; font-weight: 800; color: #FFFFFF; margin: 4px 0;">
              Dia ${c.dia_vencimento || (c.vencimento ? c.vencimento.slice(-2) : '—')}
            </div>
            <div style="font-size: 14px; font-weight: 800; color: var(--vepc-dourado-claro);">
              R$ ${(c.valor_total_centavos / 100).toFixed(2).replace('.', ',')}
            </div>
            <div style="font-size: 11px; color: var(--vepc-text-muted); margin-top: 6px;">
              <strong>${c.total_faturas} faturas</strong> &bull; ${c.pagas || 0} pagas
            </div>
          </div>
        `).join('');
      }

      // 2. Clientes em Acompanhamento
      const acompTbody = container.querySelector('#corpo-tabela-acompanhamento');
      const acomp = data.clientes_acompanhamento || [];

      if (acomp.length === 0) {
        acompTbody.innerHTML = `<tr><td colspan="7" style="text-align: center; padding: 30px; color: #10B981;">Nenhum cliente em atraso ou carência no momento.</td></tr>`;
      } else {
        acompTbody.innerHTML = acomp.map(a => `
          <tr>
            <td><strong style="color: #FFFFFF;">${a.empresa_nome}</strong></td>
            <td style="font-size: 12px; color: var(--vepc-text-muted);">
              ${a.responsavel_nome} &bull; ${a.responsavel_telefone || a.responsavel_email || 'Sem contato'}
            </td>
            <td><span class="badge badge-avaliacao">${a.plano_nome || 'Beta'}</span></td>
            <td><strong style="color: var(--vepc-dourado-claro);">R$ ${(a.valor_centavos / 100).toFixed(2).replace('.', ',')}</strong></td>
            <td style="font-family: var(--font-mono);">${a.vencimento}</td>
            <td style="font-family: var(--font-mono); color: #F59E0B;">${a.data_limite_carencia}</td>
            <td>
              <span class="badge ${a.situacao_atraso === 'em_carencia' ? 'badge-aguardando' : 'badge-vencida'}">
                ${a.situacao_atraso === 'em_carencia' ? 'EM CARÊNCIA (5D)' : 'EM ATRASO'}
              </span>
            </td>
          </tr>
        `).join('');
      }

      // 3. Custos Operacionais Registrados
      const custosTbody = container.querySelector('#corpo-tabela-custos');
      const custos = data.custos_operacionais || [];

      if (custos.length === 0) {
        custosTbody.innerHTML = `<tr><td colspan="5" style="text-align: center; padding: 30px; color: var(--vepc-text-muted);">Nenhum custo registrado ainda.</td></tr>`;
      } else {
        custosTbody.innerHTML = custos.map(c => `
          <tr>
            <td><code style="font-family: var(--font-mono);">${c.competencia}</code></td>
            <td><span class="badge badge-aberto">${c.categoria}</span></td>
            <td><strong style="color: #FFFFFF;">${c.descricao}</strong></td>
            <td><strong style="color: #F87171;">R$ ${(c.valor_centavos / 100).toFixed(2).replace('.', ',')}</strong></td>
            <td style="font-size: 11.5px; color: var(--vepc-text-muted);">${c.observacoes || c.fonte_comprovante || '—'}</td>
          </tr>
        `).join('');
      }

      // 4. Projeções Futuras
      const projDiv = container.querySelector('#container-projecoes');
      const proj = data.projecao_proximos_meses || [];

      projDiv.innerHTML = `
        <div style="display: flex; flex-direction: column; gap: 12px;">
          ${proj.map(p => `
            <div style="background: var(--vepc-surface-subtle); border: 1px solid var(--vepc-border); border-radius: var(--radius-sm); padding: 12px 16px;">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <span style="font-weight: 700; color: #FFFFFF;">${p.mes}</span>
                <span class="price-pill" style="font-size: 16px; color: var(--vepc-dourado-claro);">
                  R$ ${(p.previsto_centavos / 100).toFixed(2).replace('.', ',')}
                </span>
              </div>
              <div style="font-size: 11px; color: var(--vepc-text-subtle); margin-top: 4px;">
                Premissa: ${p.premissa}
              </div>
            </div>
          `).join('')}
        </div>
      `;

    } catch (err) {
      console.error('Falha ao carregar análise financeira:', err);
    }
  }

  // MODAL DE CONFERÊNCIA ADMINISTRATIVA
  async function abrirModalConferencia(mensalidadeId) {
    modalContainer.innerHTML = `
      <div class="modal-backdrop">
        <div class="modal-card">
          <div class="modal-header">
            <h3>Conferência Administrativa de Pagamento</h3>
            <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
          </div>
          <form id="form-conferencia">
            <div class="modal-body">
              <p style="font-size: 13px; color: var(--vepc-text-muted); margin-bottom: 16px;">
                O cliente informou ter efetuado o pagamento desta mensalidade. Confira o extrato bancário oficial da VEPC antes de aprovar.
              </p>

              <div class="form-group">
                <label class="form-label">Decisão Administrativa *</label>
                <select id="conf-decisao" class="form-control" required>
                  <option value="aprovada" selected>Aprovar Pagamento (Confirmado no extrato)</option>
                  <option value="rejeitada">Rejeitar (Pagamento não localizado)</option>
                </select>
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Forma de Pagamento</label>
                  <select id="conf-forma" class="form-control">
                    <option value="pix" selected>Pix Direto</option>
                    <option value="boleto">Boleto Bancário</option>
                    <option value="transferencia">Transferência TED/DOC</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">Data do Pagamento *</label>
                  <input type="date" id="conf-data" class="form-control" value="${new Date().toISOString().slice(0, 10)}" required />
                </div>
              </div>

              <div class="form-group">
                <label class="form-label">Observação / Comprovante (Auditada)</label>
                <input type="text" id="conf-obs" class="form-control" placeholder="Ex: Conferido no extrato bancário InfinitePay/Itaú às 14:30" />
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm btn-fechar-modal">Cancelar</button>
              <button type="submit" class="btn btn-primary btn-sm">Confirmar Decisão</button>
            </div>
          </form>
        </div>
      </div>
    `;

    modalContainer.querySelector('.btn-fechar-modal').onclick = () => { modalContainer.innerHTML = ''; };

    const formConf = modalContainer.querySelector('#form-conferencia');
    formConf.onsubmit = async (ev) => {
      ev.preventDefault();
      const decisao = modalContainer.querySelector('#conf-decisao').value;
      const forma = modalContainer.querySelector('#conf-forma').value;
      const data = modalContainer.querySelector('#conf-data').value;
      const obs = modalContainer.querySelector('#conf-obs').value;

      try {
        await api.conferirMensalidade(mensalidadeId, {
          decisao,
          forma_pagamento: forma,
          pago_em: data,
          observacao: obs
        });
        alert(`Conferência concluída com sucesso!\nStatus da mensalidade: ${decisao === 'aprovada' ? 'Paga' : 'Em Aberto'}`);
        modalContainer.innerHTML = '';
        carregarMensalidades();
      } catch (err) {
        alert('Erro ao conferir mensalidade: ' + err.message);
      }
    };
  }

  // MODAL PARA REGISTRAR CUSTO OPERACIONAL
  function abrirModalNovoCusto() {
    modalContainer.innerHTML = `
      <div class="modal-backdrop">
        <div class="modal-card">
          <div class="modal-header">
            <h3>Registrar Custo Operacional da Plataforma</h3>
            <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
          </div>
          <form id="form-novo-custo">
            <div class="modal-body">
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Competência (AAAA-MM) *</label>
                  <input type="text" id="custo-competencia" class="form-control" value="${new Date().toISOString().slice(0, 7)}" required />
                </div>
                <div class="form-group">
                  <label class="form-label">Categoria *</label>
                  <select id="custo-categoria" class="form-control" required>
                    <option value="infraestrutura">Infraestrutura em Nuvem (Cloudflare)</option>
                    <option value="inteligencia_artificial">Consumo de Inteligência Artificial</option>
                    <option value="gateways">Taxas de Meio de Pagamento</option>
                    <option value="outros">Outros Custos Operacionais</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label class="form-label">Descrição do Custo *</label>
                <input type="text" id="custo-descricao" class="form-control" required placeholder="Ex: Cloudflare Workers Paid Plan" />
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Valor em R$ *</label>
                  <input type="number" step="0.01" min="0" id="custo-valor" class="form-control" required placeholder="25,00" />
                </div>
                <div class="form-group">
                  <label class="form-label">Fornecedor / Comprovante</label>
                  <input type="text" id="custo-fonte" class="form-control" placeholder="Ex: Cloudflare Inc. Fatura #1234" />
                </div>
              </div>

              <div class="form-group">
                <label class="form-label">Premissa / Observações Transparentes</label>
                <input type="text" id="custo-obs" class="form-control" placeholder="Ex: Custo fixo mensal de computação em nuvem" />
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm btn-fechar-modal">Cancelar</button>
              <button type="submit" class="btn btn-primary btn-sm">Salvar Custo</button>
            </div>
          </form>
        </div>
      </div>
    `;

    modalContainer.querySelector('.btn-fechar-modal').onclick = () => { modalContainer.innerHTML = ''; };

    const formCusto = modalContainer.querySelector('#form-novo-custo');
    formCusto.onsubmit = async (e) => {
      e.preventDefault();
      const comp = modalContainer.querySelector('#custo-competencia').value.trim();
      const cat = modalContainer.querySelector('#custo-categoria').value;
      const desc = modalContainer.querySelector('#custo-descricao').value.trim();
      const valReais = parseFloat(modalContainer.querySelector('#custo-valor').value);
      const fonte = modalContainer.querySelector('#custo-fonte').value.trim();
      const obs = modalContainer.querySelector('#custo-obs').value.trim();

      const centavos = Math.round(valReais * 100);

      try {
        await api.registrarCusto({
          competencia: comp,
          categoria: cat,
          descricao: desc,
          valor_centavos: centavos,
          fonte_comprovante: fonte,
          observacoes: obs
        });
        alert('Custo operacional registrado com sucesso!');
        modalContainer.innerHTML = '';
        carregarAnaliseFinanceira();
      } catch (err) {
        alert('Erro ao registrar custo: ' + err.message);
      }
    };
  }

  // MODAL PARA LANÇAR NOVA MENSALIDADE
  async function abrirModalLancarMensalidade() {
    modalContainer.innerHTML = `
      <div class="modal-backdrop">
        <div class="modal-card">
          <div class="modal-header">
            <h3>Lançar Nova Mensalidade</h3>
            <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
          </div>
          <div class="modal-body" style="text-align: center; padding: 30px;">Carregando empresas ativas...</div>
        </div>
      </div>
    `;

    modalContainer.querySelector('.btn-fechar-modal').onclick = () => { modalContainer.innerHTML = ''; };

    try {
      const data = await api.getEmpresas();
      const empresas = (data.empresas || []).filter(e => e.situacao === 'ativa' || e.situacao === 'avaliacao');

      modalContainer.innerHTML = `
        <div class="modal-backdrop">
          <div class="modal-card">
            <div class="modal-header">
              <h3>Lançar Nova Mensalidade</h3>
              <button class="btn btn-secondary btn-sm btn-fechar-modal">&times;</button>
            </div>
            <form id="form-lancar-men">
              <div class="modal-body">
                <div class="form-group">
                  <label class="form-label">Empresa Cliente *</label>
                  <select id="lan-empresa" class="form-control" required>
                    <option value="">Selecione uma empresa...</option>
                    ${empresas.map(e => `
                      <option value="${e.id}" data-valor="${e.valor_mensal_contratado_centavos || 1990}" data-venc="${e.dia_vencimento || 10}">
                        ${e.nome_fantasia} (${e.cliente_beta ? '⭐ Beta' : 'Padrão'}) — R$ ${((e.valor_mensal_contratado_centavos || 1990)/100).toFixed(2).replace('.', ',')}
                      </option>
                    `).join('')}
                  </select>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Competência (AAAA-MM) *</label>
                    <input type="text" id="lan-comp" class="form-control" value="${new Date().toISOString().slice(0, 7)}" required />
                  </div>
                  <div class="form-group">
                    <label class="form-label">Valor em Centavos *</label>
                    <input type="number" id="lan-valor" class="form-control" value="1990" required />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group">
                    <label class="form-label">Data de Vencimento *</label>
                    <input type="date" id="lan-venc" class="form-control" required />
                  </div>
                  <div class="form-group">
                    <label class="form-label">Dias de Carência (Tolerância)</label>
                    <input type="number" id="lan-carencia" class="form-control" value="5" />
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm btn-fechar-modal">Cancelar</button>
                <button type="submit" class="btn btn-primary btn-sm">Emitir Fatura</button>
              </div>
            </form>
          </div>
        </div>
      `;

      modalContainer.querySelector('.btn-fechar-modal').onclick = () => { modalContainer.innerHTML = ''; };

      const selEmp = modalContainer.querySelector('#lan-empresa');
      const inputVal = modalContainer.querySelector('#lan-valor');
      const inputVenc = modalContainer.querySelector('#lan-venc');
      const inputComp = modalContainer.querySelector('#lan-comp');

      selEmp.onchange = () => {
        const opt = selEmp.selectedOptions[0];
        if (opt && opt.dataset.valor) {
          inputVal.value = opt.dataset.valor;
          const diaVenc = opt.dataset.venc || '10';
          const mes = inputComp.value || new Date().toISOString().slice(0, 7);
          inputVenc.value = `${mes}-${diaVenc.padStart(2, '0')}`;
        }
      };

      const formLan = modalContainer.querySelector('#form-lancar-men');
      formLan.onsubmit = async (e) => {
        e.preventDefault();
        try {
          await api.lancarMensalidade({
            empresa_id: selEmp.value,
            competencia: inputComp.value.trim(),
            valor_centavos: parseInt(inputVal.value, 10),
            vencimento: inputVenc.value,
            carencia_dias: parseInt(modalContainer.querySelector('#lan-carencia').value, 10)
          });
          alert('Mensalidade lançada com sucesso no painel administrativo!');
          modalContainer.innerHTML = '';
          carregarMensalidades();
        } catch (err) {
          alert('Erro ao lançar mensalidade: ' + err.message);
        }
      };

    } catch (err) {
      alert('Erro ao carregar formulário: ' + err.message);
      modalContainer.innerHTML = '';
    }
  }

  container.querySelector('#btn-filtrar-men').addEventListener('click', carregarMensalidades);
  container.querySelector('#btn-lancar-mensalidade').addEventListener('click', abrirModalLancarMensalidade);
  container.querySelector('#btn-novo-custo').addEventListener('click', abrirModalNovoCusto);
  const btnCustoAba = container.querySelector('#btn-novo-custo-aba');
  if (btnCustoAba) btnCustoAba.addEventListener('click', abrirModalNovoCusto);

  carregarMensalidades();
  return container;
}
